"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISimulationStrategySchema = exports.ISimulationStratagemRecordSchema = void 0;
const zod_1 = require("zod");
const ISimulationStratagem_1 = require("./ISimulationStratagem");
const SpiceDefinitions_1 = require("./SpiceDefinitions");
exports.ISimulationStratagemRecordSchema = zod_1.default.object({
    sourceId: zod_1.default.string(),
    sourceType: zod_1.default.enum(['inferred', 'specified']),
    stratagem: zod_1.default.lazy(() => ISimulationStratagem_1.ISimulationStratagemSchema),
});
exports.ISimulationStrategySchema = zod_1.default.object({
    analysisType: SpiceDefinitions_1.SpiceAnalysisTypeSchema,
    opts: zod_1.default.object({}).passthrough(),
    stratagems: exports.ISimulationStratagemRecordSchema.array(),
});
//# sourceMappingURL=ISimulationStrategy.js.map